class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.playButton = this.querySelector('.internal-video__play');
    this.soundButton = this.querySelector('.internal-video__sound-btn');
    this.timeline = this.querySelector('.internal-video__timeline');
    
    this.isAutoplay = this.dataset.autoplay === 'true';
    this.isNoPlayButton = this.dataset.noPlayBtn === 'true';
    this.actionOnInactive = this.dataset.actionOnInactive || 'pause';
    
    this.initializeVideo();
  }

  initializeVideo() {
    if (!this.video) return;

    // Convertir les data-src en src
    const sources = this.video.querySelectorAll('source[data-src]');
    sources.forEach(source => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    // Gérer l'autoplay
    if (this.isAutoplay) {
      this.video.muted = true;
      this.video.autoplay = true;
      this.video.loop = true;
      this.classList.add('internal-video--playing', 'internal-video--muted');
    }

    // Gérer le bouton play
    if (this.playButton) {
      if (this.isNoPlayButton) {
        this.playButton.style.visibility = 'hidden';
      } else {
        this.playButton.addEventListener('click', () => this.togglePlay());
      }
    }

    // Gérer le bouton son
    if (this.soundButton) {
      this.soundButton.addEventListener('click', () => this.toggleMute());
    }

    // Gérer la timeline
    if (this.timeline) {
      this.video.addEventListener('timeupdate', () => this.updateTimeline());
      this.timeline.addEventListener('click', (e) => this.seekTo(e));
    }

    // Gérer la visibilité
    this.observer = new IntersectionObserver(
      (entries) => this.handleVisibility(entries),
      { threshold: 0.5 }
    );
    this.observer.observe(this);

    // Charger la vidéo
    this.video.load();

    // Essayer de jouer la vidéo après un court délai
    if (this.isAutoplay) {
      setTimeout(() => {
        const playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.error('Error playing video:', error);
          });
        }
      }, 1000);
    }
  }

  togglePlay() {
    if (this.video.paused) {
      const playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          console.error('Error playing video:', error);
        });
      }
      this.classList.add('internal-video--playing');
    } else {
      this.video.pause();
      this.classList.remove('internal-video--playing');
    }
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
    this.classList.toggle('internal-video--muted');
  }

  updateTimeline() {
    if (!this.timeline) return;
    const progress = (this.video.currentTime / this.video.duration) * 100;
    this.timeline.style.width = `${progress}%`;
  }

  seekTo(e) {
    if (!this.timeline) return;
    const rect = this.timeline.getBoundingClientRect();
    const pos = (e.clientX - rect.left) / rect.width;
    this.video.currentTime = pos * this.video.duration;
  }

  handleVisibility(entries) {
    entries.forEach(entry => {
      if (!entry.isIntersecting && this.actionOnInactive === 'pause') {
        this.video.pause();
        this.classList.remove('internal-video--playing');
      }
    });
  }
}

customElements.define('internal-video', VideoPlayer);
window.pauseAllMedia = function() {
  document.querySelectorAll('video').forEach(video => {
    video.pause();
  });
}; 